<template>
  <header class="main-header" :class="{ 'menu-open': isMenuOpen, 'is-subpage': isSubpage }">
    <!-- 상단 헤더 바 -->
    <div class="header-bar">
      <div class="header-inner">
        <!-- 로고 -->
        <router-link to="/" class="logo">
          <span class="logo-text-header">청주 레이원시티 홍보관 상담센터</span>
        </router-link>

        <!-- 전화번호 + 메뉴버튼 -->
        <div class="header-right">
          <a href="tel:1666-6818" class="phone-number">
            <span class="phone-icon">&#9742;</span>
            <span class="number">1666-6818</span>
          </a>
          <button class="menu-toggle" @click="toggleMenu" aria-label="메뉴 열기">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </div>

    <!-- 풀스크린 메가메뉴 -->
    <div class="mega-menu" :class="{ 'is-open': isMenuOpen }">
      <div class="mega-menu-bg"></div>
      <img src="@/assets/logo/logo_symbol.png" alt="" class="mega-watermark" />
      <div class="mega-menu-content">
        <!-- 상단: 로고 + 전화번호 -->
        <div class="mega-header">
          <div class="mega-logo">
            <span class="logo-text">TECHNO RAYONE CITY</span>
          </div>
          <a href="tel:1666-6818" class="mega-phone">
            <span class="number">1666-6818</span>
          </a>
        </div>

        <!-- 메뉴 그리드 -->
        <div class="menu-grid">
          <div
            v-for="(menu, index) in menuData"
            :key="index"
            class="menu-column"
          >
            <h3 class="menu-title">{{ menu.title }}</h3>
            <ul class="sub-menu">
              <li v-for="(sub, subIndex) in menu.children" :key="subIndex">
                <router-link :to="sub.path" @click="closeMenu">
                  {{ sub.title }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>

        <!-- 닫기 버튼 -->
        <button class="close-btn" @click="closeMenu" aria-label="메뉴 닫기">
          <span></span>
          <span></span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MainHeader',
  computed: {
    isSubpage() {
      return this.$route.path !== '/'
    }
  },
  data() {
    return {
      isMenuOpen: false,
      menuData: [
        {
          title: '사업소개',
          children: [
            { title: '사업개요', path: '/intro/overview' },
            { title: '브랜드', path: '/intro/brand' }
          ]
        },
        {
          title: '입지안내',
          children: [
            { title: '입지환경', path: '/location/environment' }
          ]
        },
        {
          title: '상품안내',
          children: [
            { title: '단지정보', path: '/product/complex' },
            { title: '프리미엄', path: '/product/premium' },
            { title: '커뮤니티', path: '/product/community' }
          ]
        },
        {
          title: '타입안내',
          children: [
            { title: '59㎡', path: '/type/59' },
            { title: '74㎡', path: '/type/74' },
            { title: '84㎡A', path: '/type/84A' },
            { title: '84㎡A-1', path: '/type/84A-1' },
            { title: '84㎡B', path: '/type/84B' }
          ]
        },
        {
          title: '홍보센터',
          children: [
            { title: '홍보영상', path: '/media/video' }
          ]
        },
        {
          title: '방문예약',
          children: [
            { title: '관심고객등록', path: '/reservation/register' }
          ]
        }
      ]
    }
  },
  mounted() {
    window.addEventListener('open-mega-menu', this.openMenu)
  },
  beforeUnmount() {
    window.removeEventListener('open-mega-menu', this.openMenu)
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
      document.body.style.overflow = this.isMenuOpen ? 'hidden' : ''
      window.dispatchEvent(new CustomEvent('megamenu-toggle', { detail: this.isMenuOpen }))
    },
    openMenu() {
      this.isMenuOpen = true
      document.body.style.overflow = 'hidden'
      window.dispatchEvent(new CustomEvent('megamenu-toggle', { detail: true }))
    },
    closeMenu() {
      this.isMenuOpen = false
      document.body.style.overflow = ''
      window.dispatchEvent(new CustomEvent('megamenu-toggle', { detail: false }))
    }
  }
}
</script>

<style scoped>
/* 헤더 바 */
.main-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.header-bar {
  background: transparent;
  transition: background 0.3s ease, box-shadow 0.3s ease;
}

/* 서브페이지 헤더 - 흰색 고정 */
.main-header.is-subpage .header-bar {
  background: #fff;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
}

.header-inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 로고 */
.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-text-header {
  font-family: var(--font-pretendard);
  font-size: 18px;
  font-weight: 700;
  color: var(--rayone-primary);
  letter-spacing: -0.5px;
  white-space: nowrap;
}

/* 헤더 우측 */
.header-right {
  display: flex;
  align-items: center;
  gap: 24px;
}

.phone-number {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: var(--rayone-primary);
  border: 1px solid var(--rayone-primary);
  padding: 10px 20px;
  border-radius: 30px;
  transition: all 0.3s ease;
}

.phone-number:hover {
  background: var(--rayone-primary);
  color: #fff;
}

.phone-icon {
  font-size: 16px;
}

.phone-number .number {
  font-family: var(--font-paperlogy);
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
}

/* 메뉴 토글 버튼 */
.menu-toggle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}

.menu-toggle span {
  display: block;
  width: 100%;
  height: 2px;
  background: var(--rayone-primary);
  transition: all 0.3s ease;
}

.menu-open .menu-toggle span:nth-child(1) {
  transform: rotate(45deg) translate(6px, 6px);
}

.menu-open .menu-toggle span:nth-child(2) {
  opacity: 0;
}

.menu-open .menu-toggle span:nth-child(3) {
  transform: rotate(-45deg) translate(6px, -6px);
}

/* 메가메뉴 */
.mega-menu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.mega-menu.is-open {
  opacity: 1;
  visibility: visible;
}

.mega-menu-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, var(--rayone-primary) 0%, var(--rayone-primary-dark) 100%);
  transform: translateY(-100%);
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.mega-menu.is-open .mega-menu-bg {
  transform: translateY(0);
}

.mega-watermark {
  position: absolute;
  bottom: -15%;
  right: -10%;
  width: 900px;
  height: auto;
  opacity: 0.1;
  pointer-events: none;
  z-index: 0;
  filter: brightness(0) invert(1);
}

.mega-menu-content {
  position: relative;
  height: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 120px 40px 60px;
  display: flex;
  flex-direction: column;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.4s ease 0.3s;
}

.mega-menu.is-open .mega-menu-content {
  opacity: 1;
  transform: translateY(0);
}

/* 메가메뉴 상단 헤더 */
.mega-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 60px;
}

/* 메가메뉴 로고 */
.mega-logo {
  display: flex;
  flex-direction: column;
}

.mega-logo .logo-text {
  font-size: 32px;
  color: #fff;
}

/* 메뉴 그리드 */
.menu-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 40px;
  flex: 1;
}

.menu-column {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.4s ease;
}

.mega-menu.is-open .menu-column {
  opacity: 1;
  transform: translateY(0);
}

.mega-menu.is-open .menu-column:nth-child(1) { transition-delay: 0.35s; }
.mega-menu.is-open .menu-column:nth-child(2) { transition-delay: 0.4s; }
.mega-menu.is-open .menu-column:nth-child(3) { transition-delay: 0.45s; }
.mega-menu.is-open .menu-column:nth-child(4) { transition-delay: 0.5s; }
.mega-menu.is-open .menu-column:nth-child(5) { transition-delay: 0.55s; }
.mega-menu.is-open .menu-column:nth-child(6) { transition-delay: 0.6s; }

.menu-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.sub-menu {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sub-menu a {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: all 0.3s ease;
  display: inline-block;
}

.sub-menu a:hover {
  color: #fff;
  transform: translateX(8px);
}

/* 메가메뉴 전화번호 */
.mega-phone {
  display: inline-block;
  text-decoration: none;
  border: 2px solid rgba(255, 255, 255, 0.5);
  padding: 16px 32px;
  transition: all 0.3s ease;
}

.mega-phone:hover {
  border-color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

.mega-phone .number {
  font-family: var(--font-paperlogy);
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 2px;
}

/* 닫기 버튼 */
.close-btn {
  position: absolute;
  top: 40px;
  right: 40px;
  width: 48px;
  height: 48px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.close-btn span {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 32px;
  height: 2px;
  background: #fff;
}

.close-btn span:first-child {
  transform: translate(-50%, -50%) rotate(45deg);
}

.close-btn span:last-child {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.close-btn:hover span {
  background: rgba(255, 255, 255, 0.7);
}
</style>
